import PortalIdParser from 'PortalIdParser';
import { getClassicWorkflowEditRoute, getFlowChangesRoute, getFlowDetailsRoute, getFlowEditActionBaseRoute, getFlowEditRoute, getFlowReviewRoute, getFlowRevisionRoute, getFlowRoute, getFlowSettingsRoute } from 'automation-ui-routing/utils';
import BasePaths from 'automation-ui-routing/BasePaths';
export const baseWorkflowsUrl = () => `/workflows/${PortalIdParser.get()}`;
export const classicWorkflowUrl = flowId => `${baseWorkflowsUrl()}${getClassicWorkflowEditRoute(flowId)}`;
export const flowUrl = flowId => `${baseWorkflowsUrl()}${getFlowRoute(flowId)}`;
export const flowEditUrl = (flowId, query) => `${baseWorkflowsUrl()}${getFlowEditRoute(flowId, query)}`;

// CAUTION:
// flowEditActionUrl will result in a redirect in order to append the actionType
// path component to the route. For this reason, use of this function should
// be avoided for intra-canvas routing.
export const flowEditActionUrl = (flowId, actionId) => `${baseWorkflowsUrl()}${getFlowEditActionBaseRoute(flowId)}/${actionId}`;
export const flowDetailsUrl = (flowId, tabId, searchParams = {}) => `${baseWorkflowsUrl()}${getFlowDetailsRoute(flowId, tabId, searchParams)}`;
export const flowChangesUrl = flowId => `${baseWorkflowsUrl()}${getFlowChangesRoute(flowId)}`;
export const flowSettingsUrl = (flowId, tabId) => `${baseWorkflowsUrl()}${getFlowSettingsRoute(flowId, tabId)}`;
export const flowReviewUrl = flowId => `${baseWorkflowsUrl()}${getFlowReviewRoute(flowId)}`;
export const flowRevisionUrl = (flowId, revisionId, screen = BasePaths.EDIT) => {
  return `${baseWorkflowsUrl()}${getFlowRevisionRoute(flowId, revisionId)}/${screen}`;
};